import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';

function LinkModal(props) {
  const {
    header,
    url,
    onClose,
  } = props;

  const [copySuccess, setCopySuccess] = useState(false);

  const inputRef = React.useRef(null);

  const tooltip = (
    <Tooltip id="tooltip" show={copySuccess}>
      {copySuccess ? 'Copied!' : 'Copy'}
    </Tooltip>
  );

  /* istanbul ignore next */
  return (
    <>
      <Modal
        show
        onHide={onClose}
        animation={false}
      >
        <Modal.Header>
          <div className="row">
            <div className="col mx-auto text-center">
              <h3>{header}</h3>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row form-inline">
            <div className="col-10">
              <input
                ref={inputRef}
                className="form-control w-100"
                type="text"
                value={url}
                readOnly
                onFocus={() => inputRef.current.select()}
              />
            </div>
            <div className="col-2 pl-0 ml-0">
              <OverlayTrigger placement="top" overlay={tooltip}>
                <FontAwesomeIcon
                  icon={faCopy}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    inputRef.current.focus();
                    navigator.clipboard.writeText(url).then(() => {
                      setCopySuccess(true);
                    });
                  }}
                  size="lg"
                  ref={inputRef}
                />
              </OverlayTrigger>
            </div>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            <div className="col ml-auto">
              <Button
                variant="secondary"
                onClick={onClose}
              >
                Close
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

LinkModal.propTypes = {
  header: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LinkModal;
